module.exports = __webpack_public_path__ + "img/maisonette-5.ab795c2a.webp";